var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "page-title-container" }, [
    _c("div", { staticClass: "container" }, [
      _c("div", { staticClass: "row" }, [
        _vm.isActivityCategory
          ? _c("div", { staticClass: "col-sm-12 wow fadeIn" }, [
              _c("i", { staticClass: "fa fa-users" }),
              _vm._v(" "),
              _c("h1", [_vm._v("組合員活動")]),
            ])
          : _c("div", { staticClass: "col-sm-12 wow fadeIn" }, [
              _c("i", { staticClass: "fa fa-info-circle" }),
              _vm._v(" "),
              _c("h1", [_vm._v("お知らせ")]),
            ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }